import type { ID } from "@constants";
import type { IHfSearchEndpoint, IUserSearchEndpoint } from "@api/infinite";

export type IStatus = "active" | "denied" | "pending";

export type IRole =
  | "super-admin"
  | "local-admin"
  | "doctor"
  | "staff"
  | "patient"
  | "inactive-patient"
  | "admin"
  | "medical-service-provider-drug"
  | "medical-service-provider-lab"
  | "medical-service-provider-image";

export interface IOption<T extends string | number = string> {
  key: T;
  value: string;
  flag?: string;
}

export type IMetaOption<
  TMeta,
  TOption extends string | number = ID,
> = IOption<TOption> & TMeta;

export const EmptyNumberOption: IOption<number> = { key: 0, value: "" };
export const EmptyOption = { key: "", value: "" } as const;

export type IHfTypes = "hospital" | "clinic" | "health_center";
export type IGenderTypes = "male" | "female";

export interface IApiMapper<TApi, TData, TDto = TApi, TForm = TData> {
  fromApi: (data: TApi) => TData;
  toApi?: (data: TForm) => TDto;
}

export type IFileObject = INotNullableFileObject | undefined;

export interface INotNullableFileObject {
  id: ID;
  name: string;
  type: string;
  size: number;
  url: string;
}

export type IDoctor = IUserSearchEndpoint;
export type IHf = IHfSearchEndpoint;

export enum ITerminologiesKindEnum {
  Drug = 1,
  Laboratory = 2,
  Imaging = 3,
  Physiotherapy = 4,
  DoctorService = 5,
  Referral = 6,
}
